export default __webpack_public_path__ + "static/artifakt-legend-bold-ac56fa7b862f28be2b9227ff32698bc4.woff2";